<template>
  <div>
    <div class="table" v-if="withdraws.length != 0">
      <div class="table__head">
        <div class="table__row">
          <div class="table__row--cell" data-width="12">{{$t('Method')}}</div>
          <div class="table__row--cell">{{$t('State')}}</div>
          <div class="table__row--cell" data-width="12">{{$t('Amount')}}</div>
        </div>
      </div>
      <div class="table__body">
        <base-skeleton-loader
          type="billing"
          :count="this.limit"
          v-if="$apollo.queries.withdraws.loading && isFirst"
        ></base-skeleton-loader>
        <withdraw-card
          :data="withdraw"
          v-for="withdraw in withdraws"
          :key="withdraw.index"
        />
        <infinite-loading
          @infinite="infiniteHandler"
          :identifier="infiniteId"
          :distance="30"
          v-if="!isFirst"
        ></infinite-loading>
      </div>
    </div>
    <div
      class="no-record"
      v-if="withdraws.length == 0 && !$apollo.queries.withdraws.loading"
    >
      {{$t('No Record Found')}}
    </div>
  </div>
</template>

<script>
import { WITHDRAWS } from "@/graphql/user/query";
let date = new Date();
let startDate = new Date(date.getFullYear(), date.getMonth(), 1)
  .getTime()
  .toString();
let endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  .getTime()
  .toString();
export default {
  props: {
    filterDate: Object,
  },
  data() {
    return {
      state: null,
      page: 1,
      limit: 3,
      fromDate: startDate,
      toDate: endDate,
      infiniteId: +new Date(),
      hasMore: true,
      isFirst: true,
      withdraws: [],
      filter: false,
    };
  },
  components: {
    WithdrawCard: () =>
      import(
        /* webpackChunkName: "WithdrawCard" */ "@/components/user/earnings/partials/WithdrawCard.vue"
      ),
  },
  created() {
    if (this.filterDate.startDate != null) {
      this.fromDate = this.filterDate.startDate;
      this.toDate = this.filterDate.endDate;
    }
  },
  apollo: {
    withdraws: {
      query: WITHDRAWS,
      variables() {
        return {
          state: this.state,
          page: 1,
          limit: this.limit,
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
      },
      result(data) {
        if (data.data.withdraws.length < this.limit) {
          this.hasMore = false;
        } else {
          this.hasMore = true;
        }
        this.isFirst = false;
      },
    },
  },
  watch: {
    filterDate: {
      handler() {
        this.infiniteId += 1;
        this.page = 1;
        this.fromDate = this.filterDate.startDate;
        this.toDate = this.filterDate.endDate;
      },
      deep: true,
    },
  },
  methods: {
    infiniteHandler($state) {
      if (this.hasMore) {
        setTimeout(() => {
          try {
            this.page++;
            this.$apollo.queries.withdraws.fetchMore({
              variables: {
                state: this.state,
                page: this.page,
                limit: this.limit,
                fromDate: this.fromDate,
                toDate: this.toDate,
              },
              updateQuery: (previousResult, { fetchMoreResult }) => {
                const newwithdraws = fetchMoreResult.withdraws;
                if (newwithdraws.length) {
                  $state.loaded();
                } else {
                  $state.complete();
                  this.hasMore = false;
                }
                if (newwithdraws.length < this.limit) {
                  this.hasMore = false;
                }
                return {
                  withdraws: [...previousResult.withdraws, ...newwithdraws],
                };
              },
            });
          } catch (err) {
            $state.error();
          }
        }, 500);
      } else {
        $state.complete();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
